import { createContext } from 'react'

export const HomeContext = createContext<{
  [key: string]: any
}>({})
